import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { PageElementActionButton } from '../styles';

interface WrapperProps {
	isActive: boolean;
}

interface BorderProps {
	borderWidth: number;
	isActive: boolean;
}

const Wrapper = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	color: ${({ isActive }: WrapperProps) => isActive ? NewStyleColor.Blue100 : NewStyleColor.Black};
	pointer-events: auto;

	${({ isActive }: WrapperProps) => isActive && 'z-index: 1;'}
`;

const Border = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth }: BorderProps) => `${borderWidth}px`}
		solid
		${({ isActive }: BorderProps) => isActive ? `${NewStyleColor.Blue100}` : `${NewStyleColor.Grey400}`};
	border-radius: inherit;
`;

const IconLink = styled(PageElementActionButton)`
	svg {
		width: 14px;
		height: 14px;
	}
`;

export {
	Wrapper,
	Border,
	IconLink,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LinkEditor/styles.ts